var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgGift = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 56,
  height: 56,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFCC5C",
  d: "M43.313 20.22h-33.25a1.75 1.75 0 0 0-1.75 1.75v5.25a1.75 1.75 0 0 0 1.75 1.75h33.25a1.75 1.75 0 0 0 1.75-1.75v-5.25a1.75 1.75 0 0 0-1.75-1.75Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#F7B546",
  d: "M43.313 20.22h-3.5a1.75 1.75 0 0 1 1.75 1.75v5.25a1.75 1.75 0 0 1-1.75 1.75h3.5a1.75 1.75 0 0 0 1.75-1.75v-5.25a1.75 1.75 0 0 0-1.75-1.75Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFCC5C",
  d: "M28.438 28.97h13.125v19.25a1.75 1.75 0 0 1-1.75 1.75h-26.25a1.75 1.75 0 0 1-1.75-1.75V28.97h13.124"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#F7B546",
  d: "M38.063 28.97h-26.25v3.5h19.25a7 7 0 0 1 7 7v10.5h1.75a1.75 1.75 0 0 0 1.75-1.75V28.97h-3.5Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#F04C4D",
  d: "M22.313 11.47a4.374 4.374 0 1 0 0 8.75h4.375v-4.375a4.375 4.375 0 0 0-4.375-4.376Zm2.625 7h-2.625a2.625 2.625 0 1 1 2.625-2.625v2.624Zm6.125-7a4.375 4.375 0 0 0-4.375 4.374v4.376h4.375a4.376 4.376 0 0 0 0-8.75Zm0 7h-2.625v-2.625a2.625 2.625 0 1 1 2.625 2.624Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#E13340",
  d: "M31.063 18.47h.875a2.625 2.625 0 1 0 0-5.25c-.151 0-.294.019-.438.043a2.62 2.62 0 0 1-.438 5.207Zm-8.75-5.25h-.875a2.625 2.625 0 0 0 0 5.25c.15 0 .294-.02.437-.044a2.62 2.62 0 0 1 .438-5.206Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#F04C4D",
  d: "M24.938 20.22h3.5v29.75h-3.5V20.22Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFCC5C",
  d: "m39.638 9.544 2.8-.7-2.8-.7-.7-2.8-.7 2.8-2.8.7 2.8.7.7 2.8.7-2.8Zm3.15 4.9 1.4-.35-1.4-.35-.35-1.4-.35 1.4-1.4.35 1.4.35.35 1.4.35-1.4Zm1.75-7 1.4-.35-1.4-.35-.35-1.4-.35 1.4-1.4.35 1.4.35.35 1.4.35-1.4Z"
})));
export default SvgGift;